<template>
    <div>
      <button class="subscribe-btn" @click="openCheckout">Subscribe</button>
    </div>
  </template>
  
<script lang="ts" setup>


import { ref, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { defineComponent, PropType, defineEmits } from 'vue';
import { useAuthStore } from '@/stores/auth';
import { useUserStore } from '@/stores/user';
import User from '../types/User';
import { polarClient } from '@/lib/polar';

interface props {
    user: User;
}

defineOptions({ name: 'PolarSub' })

const emit = defineEmits<{
    sucribed: [];
}>();


const authStore = useAuthStore();
const userStore = useUserStore();
const router = useRouter();

const productId_sub = ref(process.env.VUE_APP_POLAR_PRODUCT_ID_SUB || '');
const productId_once = ref(process.env.VUE_APP_POLAR_PRODUCT_ID_ONCE || '');

const supaUser = ref(authStore.session?.user?.id || null);
const loading = ref(false);
const error = ref<string | null>(null);


const openCheckout = async () => {
    const theme = 'light'
    console.log(productId_once.value)
    console.log(productId_once.value)

    if (!productId_sub.value) {
        console.log('Polar product ID is minssing!')
        error.value = 'Product ID of Subscription config error'

    }

    loading.value=true;
    error.value=null;

    try {
        const checkout = await polarClient.checkouts.create({
            products: [productId_sub.value, productId_once.value],
            successUrl: `${window.location.origin}/success?checkout_id={CHECKOUT_ID}`,
            metadata: {
            user_id: supaUser.value || '',
      },
    });

    window.location.href = checkout.url;


        } catch (err: any) {
            console.error('Failed to create Polar checkout:', err);
            error.value = err.message || 'Failed to start checkout process';
        } finally {
            loading.value = false;
        }
    };

defineExpose({
  openCheckout,
  loading,
  error
});

</script>

<style scoped>

button.subscribe-btn {
  background: none;
  border: 2px solid #A1E3F9;
  font-size: 0.8rem;
  font-weight: 600;
  color: #64748b;
  cursor: pointer;
  padding: 0.6rem 1.2rem;
  border-radius: 10px;
  transition: all 0.3s ease;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  background-color: #A1E3F9;
}

button.subscribe-btn:hover {
  border-color: #578FCA;
  background-color: #578FCA;
  color: white;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
}


</style>